import { BaseRequestModel } from '../../base/base.request.model';

export class GetAccountProfileRequestMessage {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  GetAccountProfileRequestMessage!: AccountProfileSettingsRequestModel;
}

export class AccountProfileSettingsRequestModel extends BaseRequestModel {
  returnAssetTxnHistory!: boolean;
  returnActivationCodes!: boolean;
  returnPaymentMethod!: boolean;
  returnAttributes!: boolean;
  returnHardwareOps!: boolean;
  returnAccountRole!: boolean;
  returnProdCodes!: boolean;
  returnContactProfiles!: boolean;
}
